<template>
  <div class="col-3 text-right">
    <div class="row">
      <div class="col-6">
        <q-avatar size="65px">
          <img v-if="leader.image" :src="`${ (API + '/' + leader.image)}`" />
          <img v-else src="@/assets/img/user.png" />
        </q-avatar>
      </div>
      <div class="col-6 text-left q-pl-sm">
        <p class="lb-first-three-details">{{leader.name}} </p>
        <p class="lb-first-three-details">{{leader.team_name}}</p>
        <!-- <p class="lb-first-three-details">{{leader.total_score}} pts</p> -->
        <!-- <p class="lb-first-three-details">{{leader.total_time}}</p> -->
      </div>
    </div>
    <div :class="`lb-positions q-mt-md lb-positions-${position} `">
      <div class="q-block lb-positions-number"
        :style="`padding:${ position === 'two' ? '8px 0 20px 0' : (position === 'one' ? '8px 0 40px 0' : '8px 0 0 0;')}`">
        {{ position === 'two' ? 2 : (position === 'one' ? 1 : 3)}}
      </div>
      <div class="q-block lb-positions-points">{{leader.total_score}} pts</div>
    </div>
  </div>
</template>

<script>
import { API } from '../../env';
export default {
  "props": ['position', 'leader'],
  data() {
    return {
      API
    }
  }
}
</script>

<style>
.lb-positions {
  width: 68px;
  background: #fdae38;
  border-radius: 10px 10px 0 0;
  position: relative;
  margin-left: 36px
}

.lb-first-three-details {
  color: #FFF;
  font-size: 9px;
  margin-bottom: 2px !important;
}

.lb-positions-one {
  height: 100px;
  background: #f75435;
}

.lb-positions-two {
  height: 80px;
  background: #fdae38;
}

.lb-positions-three {
  height: 60px;
  background: #4fa3a5;
}

.lb-positions-number {
  color: #FFF;
  font-weight: bold;
  text-align: center;
  font-size: 24px;
}

.lb-positions-points {
  color: #FFF;
  font-weight: bold;
  font-size: 10px;
  text-align: center;
}
</style>